module.exports = __webpack_public_path__ + "0f925eadec56e107eac3140b577647af.MP3";